<script setup>
import iconInstagramPath from '../../../../../../images/sns/icon_instagram.svg'
import iconFacebookPath from '../../../../../../images/sns/icon_facebook.svg'
import iconTwitterPath from '../../../../../../images/sns/icon_x.svg'

const props = defineProps({
  postedSns: {
    type: Array,
    default: () => []
  },
})
const snsIconImage = (sns) => {
  switch( sns ) {
  case 'instagram':
    return iconInstagramPath
  case 'facebook':
    return iconFacebookPath
  case 'twitter':
    return iconTwitterPath
  }
}
</script>

<template>
  <div class="icon">
    <div v-for="(sns, i) in props.postedSns" :key="i">
      <img
        alt=""
        class="icon__img"
        :src="snsIconImage(sns)"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';

.icon {
  display: flex;
  align-items: center;

  &__img {
    margin-right: 10px
  }
}
</style>
